import React, { PropTypes } from "react"

const Info = ({ data }) => {
  return (
    <table className="table table-condensed">
      <tbody>
        <tr>
          <td width="20%">
            Section:{" "}
            <strong>{data.getIn(["offering_group", "section"])}</strong>
          </td>
          <td colSpan="2">
            Instructor:{" "}
            <strong>{data.getIn(["employee", "full_name1"])}</strong>
          </td>
          <td className="text-right">
            Control #: <strong>{data.get("id")}</strong>
          </td>
        </tr>
        {data.get("subjects").map(subject => (
          <tr key={subject.get("id")}>
            <td>
              Subject Code: <strong>{subject.get("subject_code")}</strong>
            </td>
            <td>
              Subject Description:{" "}
              <strong>{subject.get("subject_name")}</strong>
            </td>
            <td>
              Curriculum: <strong>{subject.get("curriculum_code")}</strong>
            </td>
            <td className="text-right">
              Units: <strong>{subject.get("units")}</strong>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}

Info.propTypes = {
  data: PropTypes.object,
}

export default Info



// WEBPACK FOOTER //
// ./src/containers/Print/GradesSubmitted/info.js